<script>
    import { onMount } from 'svelte';
    import { appSettings } from "../stores";

    onMount ( () => {
        $appSettings.currentPageLink = "/impressum";
        $appSettings.currentPageName = "Impressum";
        $appSettings.parentPage = "/";
        window.scrollTo(0, 0);
    })
</script>

<h1>Impressum</h1>

<h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
<p>Intermedia e.V.<br />
Irminenfreihof 8<br />
54290 Trier</p>

<p>Vereinsregister: VerR 41552<br />
Registergericht: Amtsgericht Wittlich</p>
<!-- 
<p><strong>Vertreten durch:</strong><br />
&#91;Vor- und Nachnamen der vertretungsberechtigten Personen&#93;</p> -->

<h2>Kontakt</h2>
<p>E-Mail: info@erinnerlicht-trier.de</p>

<h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
<p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

<p>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>
<style>

</style>